import { contentInitializer } from '@hb/content.initializer';
import { HypothekenBerekeningComponent } from '@hb/hypotheken-berekening.component';
import { AccordionStateService } from '@hb/services/accordion-state/accordion-state.service';
import { provideAccordionSteps } from '@hb/accordion-steps.config';

import localeNl from '@angular/common/locales/nl';
import { registerLocaleData } from '@angular/common';
import { enableProdMode, inject, importProvidersFrom, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';

import { ApAnalyticsModule } from '@ap/analytics';
import { ApContentService } from '@ap/content';
import { ApplicantDetailsResource, EnergyBonusesResource, MortgageCalculationResource } from '@ap/ap-interface-apix-hypotheken-berekening';

registerLocaleData(localeNl, 'nl');

// @ts-ignore: Needs to be ignored so the typescript compiler replaces CONFIGURATION
export const configuration: string = CONFIGURATION;

if (configuration !== 'development') {
    enableProdMode();
}

document.addEventListener('DOMContentLoaded', () => {
    bootstrapApplication(HypothekenBerekeningComponent, {
        providers: [
            provideZoneChangeDetection(),
            provideAppInitializer(contentInitializer),
            provideAppInitializer(() => {
                const accordionStateService = inject(AccordionStateService);
                accordionStateService.init();
            }),
            provideAccordionSteps(),
            importProvidersFrom(ApAnalyticsModule),
            provideHttpClient(),
            ApContentService,
            MortgageCalculationResource,
            EnergyBonusesResource,
            ApplicantDetailsResource
        ]
    }).catch((err) => console.error(err));
});
